import React from "react";

import { connect } from 'react-redux';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Info from "@material-ui/icons/Info";
import SupervisedUserCircle from "@material-ui/icons/SupervisedUserCircle";
import InsertChart from "@material-ui/icons/InsertChart";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import RecentNotes from "./Tabs/RecentNotes";
import Api from "../../api/Api.js";
import NotesEndpoints from "../../api/NotesEndpoints";
import { store } from "../../redux/store";
import { SET_RECENT_NOTES } from "../../redux/types";
import AccountManagers from "./Tabs/AccountManagers";
import Statistics from "./Tabs/Statistics";
//import Axios from "axios";
import _ from 'lodash';

const styles = {
    cardTitle,
    pageSubcategoriesTitle: {
        color: "#3C4858",
        textDecoration: "none",
        textAlign: "center"
    },
    cardCategory: {
        margin: "0",
        color: "#999999"
    },
    commentContent: {
        '&:hover': {
            cursor: 'pointer'
        }
    }
};

class Dashboard extends React.Component {

    state = {
        snackbarOpen: false,
        snackbarColor: 'danger',
        snackbarMessage: 'Not Message',
        snackbarPlace: 'tc'
        //quote: ''
    }

    componentDidMount() {
        //console.log(this.props);
        Api.get(NotesEndpoints.recent)
            .then((response) => {
                if (response) {
                    var { data } = response;
                    if (data && _.isArray(data))
                        store.dispatch({ type: SET_RECENT_NOTES, payload: data })
                }
            })
            .catch((e) => console.error(e));
        //Axios.get("https://api.chucknorris.io/jokes/random").then(({ data }) => this.setState({ quote: data.value }))
    }

    timeout;
    snackbar = (dismiss, message = '', color = 'danger', place = this.state.snackbarPlace) => {
        clearTimeout(this.timeout);
        this.setState(
            { snackbarOpen: !dismiss, snackbarColor: color, snackbarMessage: message, snackbarPlace: place },
            () => this.timeout = setTimeout(() => this.setState({ snackbarOpen: false }), 10000)
        );
    };

    render() {
        const { classes } = this.props;

        return [
            <NavPills
                key="nav"
                style={{ overflowY: 'hidden' }}
                color="rose"
                alignCenter
                tabs={[
                    { //TODO: Add Periodic Refresh
                        tabButton: "Recent Notes",
                        tabIcon: Info,
                        tabContent: (
                            <GridContainer justify="center" style={{ width: '100%' }}>
                                <GridItem xs={12} sm={12} md={8}>
                                    <RecentNotes notes={this.props.recentNotes} classes={classes} />
                                </GridItem>
                            </GridContainer>
                        )
                    },
                    {
                        tabButton: "Account Managers",
                        tabIcon: SupervisedUserCircle,
                        tabContent: (
                            <GridContainer justify="center" style={{ width: '100%' }}>
                                <GridItem xs={12}>
                                    <AccountManagers />
                                </GridItem>
                            </GridContainer>
                        )
                    },
                    {
                        tabButton: "Statistics",
                        tabIcon: InsertChart,
                        tabContent: (
                            <GridContainer justify="center" style={{ width: '100%' }}>
                                <GridItem xs={12}>
                                    <Statistics snackbar={this.snackbar} />
                                </GridItem>
                            </GridContainer>
                        )
                    }
                ]}
            />,
            <Snackbar
                key="snackbar"
                place={this.state.snackbarPlace}
                color={this.state.snackbarColor}
                message={this.state.snackbarMessage}
                open={this.state.snackbarOpen}
                closeNotification={() => this.setState({ snackbarOpen: false })}
                close
            />
            // <h5 key="chuckNorris" style={{ textAlign: 'center', fontStyle: 'italic' }}>{this.state.quote ? `❝ ${this.state.quote}❞` : ""}</h5>
        ];
    }
}

const mapStateToProps = (state) => ({ recentNotes: state.notes.recent || [] })

export default withStyles(styles)(connect(mapStateToProps)(Dashboard));